// @ts-generator-hash: 9d033ff893a0d66768dd58d3966ec1400c2602ae0b232eaa91d831bb8ea159f8
// Generation date: 8/20/2025 8:14:01 AM
// Auto-generated by CSharpToTypeScriptConverter
// Based on type: C06Camera.DL.Helpers.StepStatus
export enum StepStatus {
  NOT_STARTED = 0,
  SETUP = 1,
  READY = 2,
  GRANTEE_PENDING = 10,
  GRANTEE_PENDING_REVISION = 11,
  GRANTEE_COMPLETE = 20,
  PENDING = 30,
  PENDING_REVISION = 31,
  APPROVED = 40,
  INACTIVE = 100,
}
